import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const OnlineStatus = ({ status }) => {
  return (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor:
            status === "Online" ? "#00E41E" : "rgba(255, 255, 255, 0.5)",
        }}
      />
      <Typography
        sx={{
          color: status === "Online" ? "#00E41E" : "rgba(255, 255, 255, 0.5)",
          fontFamily: "Mulish-Medium",
          fontSize: "12px",
        }}
      >
        {status}
      </Typography>
    </Stack>
  );
};

export default OnlineStatus;
